import React from 'react';

import { DotsThreeIcon } from '@phosphor-icons/react';

import AccessibilityIcon from 'volto-ministerio-publico-federal/components/Icons/Accessibility';
import {
  MPFIconButton,
  MPFLink,
} from 'volto-ministerio-publico-federal/components/UI';
import { AccessibilityControls } from './AccessibilityControls';
import { INSTITUTIONAL_LINKS } from './constants';

export interface MobileOverflowMenuProps {
  open: boolean;
  onToggle: () => void;
  a11y: any;
  accessibilityLink: string;
  sitemapLink: string;
  /* O Header usa a caixa para o clique-fora e o botão para devolver o foco. */
  containerRef: React.RefObject<HTMLDivElement | null>;
  buttonRef: React.RefObject<HTMLButtonElement | null>;
}

/*
------------------------------------------------------------
Menu de opções do mobile (o "…" da faixa branca)
------------------------------------------------------------
Reúne o que na faixa superior do desktop fica sempre à vista: os links
institucionais, o atalho para a página de acessibilidade e os quatro
controles. Abaixo de 1024px não há espaço para essa fileira, e a navegação
tem barra própria — daí o menu de transbordo.
------------------------------------------------------------
*/
export const MobileOverflowMenu: React.FC<MobileOverflowMenuProps> = ({
  open,
  onToggle,
  a11y,
  accessibilityLink,
  sitemapLink,
  containerRef,
  buttonRef,
}) => {
  return (
    <div className="mpf-topbar__overflow" ref={containerRef}>
      <MPFIconButton
        ref={buttonRef}
        variant="unstyled"
        // `square`: o padrão `circle` do MPFIconButton traz `rounded-full` e
        // atropelaria o raio de 8px que o layout pede.
        shape="square"
        className="mpf-topbar__overflow-button"
        aria-haspopup="true"
        aria-expanded={open}
        aria-controls="mpf-topbar-overflow"
        label="Mais opções"
        onClick={onToggle}
        icon={
          <DotsThreeIcon
            className="mpf-topbar__overflow-button-icon"
            weight="bold"
          />
        }
      />

      {open && (
        <div id="mpf-topbar-overflow" className="mpf-topbar__overflow-menu">
          {INSTITUTIONAL_LINKS.map((link) => (
            <MPFLink
              key={link.href}
              href={link.href}
              className="mpf-topbar__overflow-link"
              openInNewTab={link.external || undefined}
            >
              {link.label}
            </MPFLink>
          ))}

          <a
            href={accessibilityLink}
            className="mpf-topbar__overflow-link mpf-topbar__overflow-link--icon"
          >
            <AccessibilityIcon
              className="mpf-topbar__overflow-link-icon"
              aria-hidden="true"
            />
            Acessibilidade
          </a>

          <div className="mpf-topbar__overflow-controls">
            <AccessibilityControls
              a11y={a11y}
              variant="mobile"
              sitemapLink={sitemapLink}
              fontOrder="increase-first"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileOverflowMenu;
